import {
  IExhibitorsDashboardTranslations,
  IExhibitorTickets,
  IExhibitorExports,
  IExhibitorVisitors,
  IExhibitorSidebar,
  IExhibitorSettingsTranslations,
  IExhibitorProducsTranslations,
  IExhibitorInteractionsTranslations,
  IExhibitorOnboardingTranslations,
  IExhibitorSessions,
  IExhibitorProductInteractions,
  IExhibitorProfile,
} from '@/translations/default/exhibitors';

const dashboard: Partial<IExhibitorsDashboardTranslations> = {
  // leave empty until needed
};

const tickets: Partial<IExhibitorTickets> = {
  // leave empty until needed
};

const exports: Partial<IExhibitorExports> = {
  // leave empty until needed
};

const visitors: DeepPartial<IExhibitorVisitors> = {
  filters: {
    interacted_with_product: 'Interacted with product',
  },
};

const sidebar: Partial<IExhibitorSidebar> = {
  exhibitor_interactions: 'Interesados en tu empresa',
  interactions: 'Visitantes',
  products: 'Productos',
  product_interactions: 'interesados en produtos',
};

const settings: Partial<IExhibitorSettingsTranslations> = {
  // leave empty until needed
};

const products: Partial<IExhibitorProducsTranslations> = {
  title: 'Productos',
  subtitle: 'Crear, editar y eliminar productos',
  no_products: 'No hay productos disponibles',
  new_product: 'Nuevo producto',
  edit_product: 'Editar producto',
  delete_confirm: 'Está seguro de que desea eliminar este producto?',
  interactions_exist_cannot_delete:
    'Este producto ya tiene interacciones, por lo que no es posible eliminar',
};

const interactions: Partial<IExhibitorInteractionsTranslations> = {
  // leave empty until needed
};

const onboarding: Partial<IExhibitorOnboardingTranslations> = {
  // leave empty until needed
};

const sessions: Partial<IExhibitorSessions> = {
  private_session_warning:
    'Si la sesión es privada, sólo la verán los participantes invitados. Si es una sesión pública, será visible para todos los participantes.',
};

const productInteractions: Partial<IExhibitorProductInteractions> = {
  title: 'interesados en produtos producto',
  subtitle:
    'Mira la lista de visitantes interesados en tus productos, chatea con ellos o envíales una reunión',
  product_name: 'Producto',
};

const profile: Partial<IExhibitorProfile> = {
  products: 'Angebote',
};

export default {
  dashboard,
  settings,
  interactions,
  onboarding,
  sidebar,
  sessions,
  products,
  productInteractions,
  exports,
  visitors,
  profile,
  tickets,
};
